import { render, staticRenderFns } from "./ghz-authorization.vue?vue&type=template&id=c8d19f94&"
import script from "./ghz-authorization.vue?vue&type=script&lang=js&"
export * from "./ghz-authorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports